import * as TYPES from './window-actiontypes';

const initialState = {
  size: '',
};

export const windowReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case TYPES.WINDOW_RESIZE:
      newState = { ...state, size: action.size };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default windowReducer;
